import { StyledButton, ButtonIcon } from '../styled-button'

export const FinishedButton: React.FC<IStyledButton> = ({ ...props }) => (
  <StyledButton {...props} disabled greenGradient as="button">
    <ButtonIcon className="fas fa-check" />
  </StyledButton>
)

export default FinishedButton
